import {get} from '@/lib/axios';

export default {
    async getConsentLink() {
        return get(`/consent-link`);
    }
}